import { Column, Entity, PrimaryColumn } from 'typeorm';
import { InspectionImage } from '../../_objects/inspection-image';
import { AnnotationImageDetail } from '../../_objects/inspection-image-annotation';
import { BaseSchema } from '../abstracts/base.schema';

export class InspectionImageBaseSchema extends BaseSchema {
  @PrimaryColumn()
    id: string;

  @Column()
    inspectionId: string;

  @Column({ nullable: true })
    subjectLocationId: string | null;

  @Column({ nullable: true })
    mimeType: string | null;

  @Column({ nullable: true })
    fileName: string | null;

  @Column({ unique: true, nullable: true })
    filePath: string | null;

  @Column({ unique: true, nullable: true })
    localFilePath: string | null;

  @Column({ unique: true, nullable: true })
    audioFilePath: string | null;

  @Column({ nullable: true })
    thumbFilePath: string | null;

  @Column({ nullable: true, length: 1000 })
    comment: string;

  @Column({ nullable: true })
    metadata: string | null;

  @Column({ nullable: true })
    isDataPlate: boolean | null;

  @Column({ nullable: true })
    sortOrder: number | null;

  @Column({ nullable: true })
    usedImageMode: number | null;

  @Column({ nullable: true })
    createDate: string | null;

  @Column({ nullable: true })
    lastUpdateDate: string | null;

  @Column({ nullable: true })
    OfflineId: string | null;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    isValid: boolean | null;

  @Column({ nullable: true })
    rowVersion: string | null;

  @Column({ nullable: true })
    imageDescription: string | null;

  @Column({ nullable: true })
    imageType: string | null;

  @Column({ nullable: true })
    datetime: string | null;

  @Column({ nullable: true })
    scopeModel: string | null;

  @Column({ nullable: true })
    vegaMeasurement: string | null;

  @Column({ nullable: true })
    orientation: number | null;

  @Column({ nullable: true })
    width: number | null;

  @Column({ nullable: true })
    height: number | null;

  @Column({ nullable: true })
    originalMimeType: string | null;

  @Column({ nullable: true })
    status: string | null;

  @Column({ nullable: true })
    isOfflineData: boolean | null;

  @Column({ nullable: true })
    manageUserId: string | null;

  @Column({ nullable: true })
    bookMarkOption: string | null;

  setInspectionImage(inspectionImage: InspectionImage, tenantId: string, userId: string) {
    this.id = inspectionImage.id;
    this.inspectionId = inspectionImage.inspectionId;
    this.subjectLocationId = inspectionImage.subjectLocationId;
    this.mimeType = inspectionImage.mimeType;
    this.fileName = inspectionImage.fileName;
    this.filePath = this.extractFilePath(inspectionImage.originalFilePath);
    this.thumbFilePath = this.extractThumbFilePath(inspectionImage.originalFilePath);
    this.comment = inspectionImage.comment;
    this.metadata = JSON.stringify(inspectionImage.metadata);
    this.isDataPlate = inspectionImage.isDataPlate;
    this.sortOrder = inspectionImage.sortOrder;
    this.usedImageMode = inspectionImage.usedImageMode;
    this.createDate = inspectionImage.createDate;
    this.lastUpdateDate = inspectionImage.lastUpdateDate;
    this.isDeleted = false;
    this.isValid = true;
    this.schemaVersion = inspectionImage.schemaVersion;
    this.createdBy = inspectionImage.createdBy;
    this.lastUpdatedBy = inspectionImage.lastUpdatedBy;
    this.imageDescription = inspectionImage.imageDescription;
    this.imageType = inspectionImage.imageType;
    this.datetime = inspectionImage.datetime;
    this.orientation = inspectionImage.originalOrientation;
    this.originalMimeType = inspectionImage.originalMimeType;
    this.status = '900';
    this.isOfflineData = false;
    this.tenantId = tenantId;
    this.manageUserId = userId;
    this.width = inspectionImage.originalWidth;
    this.height = inspectionImage.originalHeight;
    this.scopeModel = inspectionImage.scopeModel;
    if (inspectionImage?.bookMarkOption) {
      this.bookMarkOption = JSON.stringify(inspectionImage.bookMarkOption);
    }
    if (inspectionImage.uploadAudioUrl) {
      this.audioFilePath = `inspections/${inspectionImage.inspectionId}/audio/${inspectionImage.id}.wav`;
    }
  }

  protected extractFilePath(filePath: string) {
    // 'inspections'から後ろを取得
    const term = 'inspections';
    const indexOfTerm = filePath.indexOf(term);
    const temp = indexOfTerm > 0
      ? filePath.slice(indexOfTerm)
      : filePath;

    // '?'より後ろを削除
    const indexOfQ = temp.indexOf('?');
    const result = indexOfQ > 0
      ? temp.slice(0, indexOfQ)
      : temp;

    return decodeURIComponent(result);
  }

  protected extractThumbFilePath(originalFilePath: string) {
    const result = this.extractFilePath(originalFilePath);

    // filesをthumbsに変換し、サムネイルパスを作成する
    return result.replace('/files/', '/thumbs/');
  }

}

@Entity()
export class InspectionImageSchema extends InspectionImageBaseSchema {
  @Column({ nullable: true })
    modifiedItems: string | null;

  @Column({ nullable: true })

    modifiedWidth: number | null;

  @Column({ nullable: true })
    modifiedHeight: number | null;

  @Column({ nullable: true })
    measurementItems: string | null;

  @Column({ nullable: true })
    measurementWidth: number | null;

  @Column({ nullable: true })
    measurementHeight: number | null;

  @Column({ nullable: true })
    isMeasurementEnabled: boolean = false;

  setInspectionImageDetail(inspectionImage: InspectionImage, annotation: AnnotationImageDetail, tenantId: string, userId: string) {
    this.setInspectionImage(inspectionImage, tenantId, userId);

    if (annotation) {
      if (annotation.modifiedItems) {
        this.modifiedItems = JSON.stringify(annotation.modifiedItems);
      }

      if (annotation.measurementItems) {
        this.measurementItems = JSON.stringify(annotation.measurementItems);
      }

      this.modifiedWidth = annotation.modifiedWidth;
      this.modifiedHeight = annotation.modifiedHeight;
      this.measurementWidth = annotation.measurementWidth;
      this.measurementHeight = annotation.measurementHeight;
    }
  }

}

export class InspectionImageSchemaUpdate {
  id: string;
  inspectionId: string;
  subjectLocationId: string;
  comment: string;
  metadata: string;
  sortOrder: number;
  isDataPlate: boolean;
  fileName: string;
  filePath: string;
  thumbFilePath: string;
  localFilePath: string;
  bookMarkOption?: string;
}
